import React from 'react';
import './CookieButton.css';

const RevisedCookieButton: React.FC = () => {
  const openCookiePreferences = () => {
    // Dispatch a custom event to trigger the opening of the cookie preferences modal
    window.dispatchEvent(new CustomEvent('openCookiePreferences'));
  };
  
  return (
    <button 
      className="cookie-settings-button"
      onClick={openCookiePreferences}
      aria-label="Open Cookie Preferences"
    >
      <span className="cookie-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.95 10.99C21.75 9.04 20.96 7.23 19.7 5.73C18.44 4.23 16.77 3.09 14.9 2.36C14.83 2.33 14.76 2.31 14.68 2.31C14.6 2.3 14.53 2.31 14.46 2.33C14.32 2.37 14.19 2.44 14.08 2.55C13.98 2.66 13.9 2.79 13.87 2.93C13.82 3.13 13.77 3.33 13.73 3.52C13.58 4.35 13.27 5.15 12.82 5.87C12.37 6.59 11.78 7.21 11.09 7.71C10.41 8.19 9.63 8.54 8.81 8.74C7.99 8.94 7.13 8.99 6.29 8.87C5.35 8.76 4.44 8.82 3.56 9.05C3.1 9.17 2.67 9.35 2.28 9.6C2.13 9.69 2.01 9.83 1.93 9.99C1.85 10.15 1.82 10.33 1.83 10.51C2.02 13.15 3.2 15.61 5.1 17.37C7 19.13 9.48 20.06 12.02 20C12.39 20 12.76 20 13.12 19.96C14.99 19.78 16.77 19.05 18.24 17.86C19.71 16.67 20.82 15.06 21.44 13.23C21.8 12.22 21.99 11.14 22 10.05C22 10.03 22 10.01 22 9.99H21.95V10.99Z" fill="currentColor"/>
          <circle cx="7.5" cy="14.5" r="1.5" fill="white"/>
          <circle cx="14.5" cy="13.5" r="1.5" fill="white"/>
          <circle cx="10.5" cy="16.5" r="1.5" fill="white"/>
        </svg>
      </span>
      <span className="cookie-text">Cookie Settings</span>
    </button>
  );
};

export default RevisedCookieButton;